import src from "IMAGE";
export default { src, width: 199, height: 30, blurWidth: 0, blurHeight: 0};
